// A dynamic import() of a CommonJS/UMD package (exceljs, jszip) resolves to
// the CJS exports object in the Parcel production bundle, with no `default`
// (Parcel does not add default interop to dynamic imports), while Jest and
// the dev server add one. Read the export either way.
export const moduleDefault = (mod) => mod?.default ?? mod;
